import * as React from "react";

function SvgTop(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M3 3h14v2H3zM10.6 17.1H9.4V8.4L8.1 9.7 7 9l3-3 3 3-1.1.8-1.3-1.3v8.6z" /></svg>;
}

export default SvgTop;